import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Page, Layout, BlockStack, Text, InlineStack, Grid, Card, Box, List } from '@shopify/polaris';
import { useSelector } from 'react-redux';
import { getAllUserOnboarding } from '../redux/userOnboarding/slice';
import MetafieldAttributes from '../components/setup-metafield/MetafieldAttributes';
import Placeholder from '../components/common/Placeholder';
import { SETUP_METAFIELDS_ITEMS } from '../utils';

const SetupMetafieldPage = () => {
    const navigate = useNavigate();
    const { userOnboardingData } = useSelector(getAllUserOnboarding);

    const CustomTitle = (
        <BlockStack gap='200'>
            <InlineStack align='space-between' blockAlign='center'>
                <Text variant="headingLg" as="h5">
                    Setup Metafields
                </Text>
            </InlineStack>
            <Text as='p' variant='bodyMd'>
                To ensure accurate pricing, you need to add specific metafields to each product in your store.
            </Text>
        </BlockStack>
    );

    return (
        <Page title={CustomTitle} backAction={!userOnboardingData?.is_onboarding ? { content: 'Back', onAction: () => navigate('/') } : undefined}>
            <Layout sectioned={!userOnboardingData?.is_onboarding}>
                <Layout.Section variant='fullWidth'>
                    <Grid columns={3}>
                        {SETUP_METAFIELDS_ITEMS.map((item) => (
                            <Grid.Cell columnSpan={{ xs: 6, lg: 4 }} key={item.id}>
                                <Card padding='0'>
                                    <InlineStack align='space-between' blockAlign='center'>
                                        <Box padding='400' paddingBlockEnd='400'>
                                            <BlockStack gap='200'>
                                                <Text variant="headingMd" as="h6">
                                                    {item.heading}
                                                </Text>
                                                <Text as='p' variant='bodyMd'>
                                                    {item.description}
                                                </Text>
                                                <List>
                                                    {item.steps.map((step, index) => (
                                                        <List.Item key={index}>
                                                            <span dangerouslySetInnerHTML={{ __html: step }} />
                                                        </List.Item>
                                                    ))}

                                                </List>
                                            </BlockStack>
                                        </Box>
                                    </InlineStack>
                                </Card>
                            </Grid.Cell>
                        ))}
                    </Grid>
                </Layout.Section>
                <Layout.Section>
                    <MetafieldAttributes />
                </Layout.Section>
            </Layout>
            <Placeholder />
        </Page>
    );
};

export default SetupMetafieldPage;
